module.exports = __webpack_public_path__ + "img/125.6c2599ff.jpg";